import React, { Component } from 'react';
import { IMAGE_FULL_URL } from '../../../config/config';
import * as moment from 'moment';
import 'moment/locale/th';
import PreviewImage from '../../../views/PreviewImage/';
import NumberFormat from 'react-number-format';
import {  Modal, ModalBody } from 'reactstrap';

class CarRepairListItem extends Component{
  constructor (props){
    super(props)

    this.state = {
      preview_image_url: '',
      preview_image_select: false,
    }
    this.onCarRepairDelete  = this.onCarRepairDelete.bind(this)
    this.togglePreviewImage = this.togglePreviewImage.bind(this)
  }

  onCarRepairDelete(car_repair){
    this.props.onCarRepairDelete(car_repair)
  }
  onPreviewSelected(url){
    this.setState({
      preview_image_url: url,
      preview_image_select: true
    });
  }
  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select
    });
  }

  render(){

    var car_repair_list = this.props.lists.map((car_repair,index)=>{
      return(
        <tr key={index} >
          <td className="text-center">{index+1}</td>
          <td className="text-center">
            {car_repair.car_repair_name}
            <br/>
            <span className="badge badge-danger">
              {car_repair.car_repair_type}
            </span>
          </td>
          <td className="text-center">
            &nbsp;&nbsp;ส่งซ่อม : {moment(car_repair.car_repair_send).locale('th').format('LL')} <br/>
            ซ่อมเสร็จ : {moment(car_repair.car_repair_complete).locale('th').format('LL')}
          </td>
          <td className="text-center">
            <img
              src={IMAGE_FULL_URL + car_repair.car_repair_file}
              style={{'cursor' : 'pointer', 'width': '120px', 'height': 'auto'}}
              onClick={()=>this.onPreviewSelected(IMAGE_FULL_URL + car_repair.car_repair_file)}
              alt="เอกสาร"
            />
          </td>
          <td className="text-center">
            <NumberFormat value={car_repair.car_repair_cost} displayType={'text'} thousandSeparator={true} prefix={'฿'} />
          </td>
          <td className="text-center">
            {car_repair.fullname}<br/>
            {moment(car_repair.updated_at).locale('th').format('DD-MM-YYYY HH:mm')}
          </td>
          <td className="text-center">
            <button className="btn btn-sm btn-danger btn-md-width"
                    onClick={()=>this.onCarRepairDelete(car_repair)}
            >
              <i className="fa fa-remove"></i> ลบ
            </button>
          </td>
        </tr>
      )
    })

    return(
      <div>
        <table className={(this.props.lists.length>0)?'table table-striped ' : 'table table-striped hidden'}>
          <thead>
          <tr>
            <th className="text-center">#</th>
            <th className="text-center">ชื่อรายการ</th>
            <th className="text-center">วันที่ส่งซ่อม/ซ่อมเสร็จ</th>
            <th className="text-center">เอกสารแนบ</th>

            <th className="text-center">ราคา</th>
            <th className="text-center">ผู้ทำรายการ</th>
            <th className="text-center">&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          {car_repair_list}
          </tbody>
        </table>

        <div className={this.props.lists.length ===0 ?' text-center  ' : 'hidden'} >
          <strong className="text-danger">ไม่พบรายการซ่อม</strong>
        </div>

        <Modal isOpen={this.state.preview_image_select} toggle={this.togglePreviewImage} className={'modal-lg '}>
          <ModalBody>
            <PreviewImage
              imageUrl={this.state.preview_image_url}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default CarRepairListItem
